import { InjectionToken } from '@angular/core';

export interface SiteConfigData {
    /** Parsed Organization JSON-LD object, or null if the source was empty/unparseable. */
    organization: Record<string, unknown> | null;
    /** Error message captured at fetch time when JSON.parse failed. Null when content was valid or empty. */
    parseError: string | null;
    /** ISO timestamp of the last successful data refresh (the time the current `organization` was fetched). */
    lastUpdatedAt?: string;
    /** ISO timestamp of the most recent fetch attempt, regardless of outcome. */
    lastFetchAttemptAt?: string;
    /** Error message from the most recent fetch attempt that failed at the HTTP/network layer. Null on success. */
    fetchError?: string | null;
}

export const SITE_CONFIG_DATA = new InjectionToken<SiteConfigData>('SITE_CONFIG_DATA');
